import { Component, OnInit, inject } from '@angular/core';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
import { ModalController, IonButtons, IonHeader, IonTitle, IonToolbar, IonIcon, IonContent, IonItem, IonGrid ,
         IonBadge , IonList,IonAccordion,IonAccordionGroup,IonLabel} from "@ionic/angular/standalone";

import { TranslateModule } from '@ngx-translate/core';
import { addIcons} from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
    selector: 'app-info-conexion',
    templateUrl: './info-conexion.component.html',
    styleUrls: ['./info-conexion.component.scss'],
    standalone: true,
    imports: [IonHeader, IonToolbar, IonTitle, IonButtons, IonIcon, IonContent, IonItem, IonGrid,
              IonList, IonBadge, IonLabel, IonAccordion,IonAccordionGroup, TranslateModule]
})
export class InfoConexionComponent implements OnInit {
  variables = inject(VariablesGlobalesService);
  modalController = inject(ModalController);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { addIcons({close}); }

  ngOnInit() {}

  dismissModal() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  tipoPeticion(tipo: string) {
    if (tipo === 'PUT') {
      return 'Modificar Cliente'
    } else if (tipo === 'PATCH') {
      return 'Crear Cliente'
    }
  }
}
